(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("rxjs"), require("js-cookie"));
	else if(typeof define === 'function' && define.amd)
		define("rx-http", ["lodash", "rxjs", "js-cookie"], factory);
	else if(typeof exports === 'object')
		exports["rx-http"] = factory(require("lodash"), require("rxjs"), require("js-cookie"));
	else
		root["rx-http"] = factory(root["_"], root["Rx"], root["Cookies"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_28__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition